import axios from 'axios'
import swal from 'sweetalert2';

const client = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    json: true
  })

export default {
    async execute (method, resource, data) {
      return client({
        method,
        url: resource,
        data
      }).then(req => {
        return req.data
      })
    }, 
    login(userid, pass){
      return this.execute('post',`/logincust`, {"userid":userid, "pass":pass});
    },
    aktivasi(userid){
        return this.execute('get',`/login/${userid}`);
    },
    reaktivasi(userid){
        return this.execute('get',`/reactivate/${userid}`);
    },
    forget(userid){
      return this.execute('get', `/forgePass/${userid}`);
    },
    getQRFrontPage(data){
      return this.execute('get',`/fp/${data}`);
    },
    async sertifikasiDownload(data, loader){
      axios({
        baseURL: process.env.VUE_APP_API_URL,
        method: "get",
        url: `/fp/sertifikat/${data}`,
        responseType: "arraybuffer",
      }).then(function (response) {
        if (response.data.byteLength < 1000){
           var res = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(response.data)));
           swal.fire({
            title: "Download Sertifikat",
            text: `${res.err}`,
            icon: "error",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }else{
          let blob = new Blob([response.data], { type: "application/pdf" });
          if (blob.size > 0) {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download =  "Sertifikat.pdf";
            link.click();
            swal.fire({
              title: "Download File",
              text: `Sertifikat Selesai`,
              icon: "info",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          } else {
            swal.fire({
              title: "Download File",
              text: `File Belum Tersedia !!`,
              icon: "error",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          }
        }
        /*
        */
        if (loader != undefined) loader.close();
      });
    },
    cekSertifikat (regNbr) {
      return this.execute('get',`/cekSertifikat/${regNbr}`);
    }
}
